// BUG-2357: completed (fbOrderStatus "CO") db.fbOrderData rows are kept for the rest of the
// day they were completed. Deleting them straight away let getFBOrdersData() re-insert a
// settled order the server still had open as "IP", and the next customer's KOT was appended
// to it. A kept row makes insertFbOrdersToDB skip that fbOrderId and lets the stale-IP guards
// (useWebSocketHandler ORDER_UPSERT, handleTable's isStaleServerState) recognise it.
//
// Shared by cleanupCompletedOrders (useOrderHandlers.js) and syncOrders (tables.js) so the two
// deletion paths can't drift apart. Same UTC-date convention as the existing stale-IP rule.

export const todayKey = () => new Date().toISOString().split("T")[0];

// True when a completed row may be deleted: it has no completion time, or it was completed
// on an earlier day than `today`.
export const isCompletedOrderExpired = (order, today = todayKey()) =>
  !order?.updatedTime || !String(order.updatedTime).startsWith(today);
